import styled from "styled-components";

export const Backdrop = styled.div`
    background-color: rgba(0,0,0,0.5);
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 9999;
`;